import { render, staticRenderFns } from "./CustomerUpdateDialogType.vue?vue&type=template&id=0571c59e&scoped=true"
import script from "./CustomerUpdateDialogType.vue?vue&type=script&lang=ts"
export * from "./CustomerUpdateDialogType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0571c59e",
  null
  
)

export default component.exports